import { Box, CircularProgress } from "@mui/material";
import {
  Tabs
} from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { SalonAPI } from "../../../api/Salon";
import InfoTab from "../InfoTab";
import Photos from "../Photos";
import Services from "../Services";
import { Settings } from "../Settings";
import { useBreadcrumbLabel } from "../../../components/breadcrumb/BreadcrumbContext";

const EditSalon = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [loadingData, setLoadingData] = useState(false);

  const [infoData, setInfoData] = useState<SalonInfo | null>(null);
  useBreadcrumbLabel(infoData?.business?.business_name);
  const [dataPhoto, setDataPhoto] = useState<PhotosSalon>({
    featured_photo: "",
    photos: [],
  });
  const [dataSetting, setDataSetting] = useState<SalonSetting | null>(null);

  useEffect(() => {
    if (!id) return;
    setLoadingData(true);
    
    Promise.all([
      SalonAPI.getSalonInfo(id),
      SalonAPI.getSalonSetting(id),
      SalonAPI.getSalonPhoto(id)
    ])
      .then(([infoResponse, settingResponse, photoResponse]) => {
        setInfoData(infoResponse.data.data);
        setDataSetting(settingResponse.data.data);
        setDataPhoto(photoResponse.data.data);
      })
      .catch((error) => {
        console.error('Error fetching salon data:', error);
      })
      .finally(() => {
        setLoadingData(false);
      });
  }, [id]);

  const items = [
    {
      label: t("salon.edit_tabs.basic_info"),
      key: "info",
      children: (
        <InfoTab
          infoData={infoData}
        />
      ),
    },
    {
      label: t("salon.edit_tabs.photos"),
      key: "Photos",
      children: (
        <Photos
          data={dataPhoto}
        />
      ),
    },
    {
      label: t("salon.edit_tabs.services"),
      key: "services",
      children: <Services outletId={id} />,
    },
    {
      label: t("salon.edit_tabs.setting"),
      key: "setting",
      children: (
        <Settings
          settingData={dataSetting}
          onChange={setDataSetting}
        />
      ),
    },
  ];

  if (loadingData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box>
      <Box fontWeight={"bold"} fontSize="24px" mb={2}>
        {t("salon.title.edit")}
      </Box>
      <Tabs items={items} tabBarStyle={{ borderBottomColor: "var(--app-text)" }} />
    </Box>
  );
};

export default EditSalon;
